<p class="govuk-!-font-size-27"><ng-content select="[metric-desc]"></ng-content></p>

<highcharts-chart class="chart" [Highcharts]="Highcharts" [options]="options"></highcharts-chart>
